import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
export const unitPrice = (g, qty) => {
  const hit = (g.bulk_tiers || []).filter((t) => qty >= t.min).map((t) => t.price);
  return hit.length ? Math.min(...hit) : g.price;
};
export const openChat = (text) => window.dispatchEvent(new CustomEvent("open-chat", { detail: { text } }));
export const TELEGRAM_URL = "https://t.me/Randal782";
export const isOut = (g) => g.stock <= 0 && !g.oversell;
export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x.msg).replace(/^Value error, /, "")).join(", ");
  return fallback;
};

export const NETWORK_INFO = {
  TRC20: { label: "TRC20", chain: "Tron", color: "#EF4444" },
  ERC20: { label: "ERC20", chain: "Ethereum", color: "#8B5CF6" },
  SOL: { label: "SOL", chain: "Solana", color: "#06B6D4" },
  BEP20: { label: "BEP20", chain: "BNB Chain", color: "#F59E0B" },
};

export const PLATFORM_STYLE = {
  Steam: { bg: "#1b2838", fg: "#66c0f4" },
  Rockstar: { bg: "#fcaf17", fg: "#111" },
  Xbox: { bg: "#107c41", fg: "#fff" },
  Mixed: { bg: "#10B981", fg: "#08090C" },
  Epic: { bg: "#2a2a2a", fg: "#fff" },
  PlayStation: { bg: "#0070d1", fg: "#fff" },
  "Battle.net": { bg: "#148eff", fg: "#fff" },
  Other: { bg: "#374151", fg: "#e5e7eb" },
};

export const GAME_PLATFORMS = ["Steam", "Rockstar", "Xbox", "Epic", "PlayStation", "Battle.net", "Other"];
